import * as React from 'react'
import OutboxIcon from '@mui/icons-material/Outbox'
import {
  ArrayField,
  Datagrid,
  EditButton,
  FunctionField,
  Link,
  ReferenceArrayField,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
  useRecordContext,
} from 'react-admin'
import { shopifyProviderPortalTag } from '../../env'
import { formatPhoneDisplay } from '../../utils/phone'
import moment from 'moment'

export default function ProviderAccessDetail() {
  const record = useRecordContext()

  const Title = () => {
    return record && <p>Provider #{record.id}</p>
  }

  return (
    <Show
      resource="provider-access/users"
      actions={
        <TopToolbar>
          <EditButton resource="provider-access" />
        </TopToolbar>
      }
      title={<Title />}
    >
      <SimpleShowLayout spacing={2} className="details-page-layout">
        <TextField label="Id" source="id" />
        <FunctionField label="Name" render={(record) => record.first_name + ' ' + record.last_name} />
        <FunctionField label="Phone" render={(record) => formatPhoneDisplay(record.phone ?? record.default_address?.phone) || 'Not Added Yet'} />
        <TextField label="Email" source="email" />
        <TextField label="Email Verified" source="verified_email" emptyText="Not Added Yet" />
        <TextField label="State" source="state" emptyText="N/A" />
        <ArrayField label="Notification" source="notification">
          <Datagrid bulkActionButtons={false}>
            <TextField label="Method" source="method" />
            <TextField label="Type" source="type" />
            <FunctionField label="Timestamp" render={(record) => moment(record.timestamp).format('YYYY-MM-DD HH:mm:ss')} />
          </Datagrid>
        </ArrayField>
        <FunctionField
          label="Access to Provider Portal"
          render={(record) => (record.tags.includes(shopifyProviderPortalTag) ? 'Yes' : 'No')}
        />
        <FunctionField
          label={
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <OutboxIcon fontSize="small" />
              Kit Requests
            </span>
          }
          render={(record) => (record.kitRequests ? 'Enabled' : 'Disabled')}
        />
        <ReferenceArrayField link="show" reference="provider-groups" source="providerGroupIds" label="Provider Groups">
          <Datagrid bulkActionButtons={false}>
            <TextField source="name" label="Group Name" />
          </Datagrid>
        </ReferenceArrayField>
        <ReferenceArrayField link="show" reference="providers" source="providerIds" label="Providers (Individual)">
          <Datagrid bulkActionButtons={false}>
            <FunctionField
              label="Display Name"
              render={(record) => <Link to={`/providers/${record.providerId}/show`}>{record.displayName}</Link>}
            />
          </Datagrid>
        </ReferenceArrayField>
      </SimpleShowLayout>
    </Show>
  )
}
